import validateVar from "./validation/validateVariable";

function getMarketIdentifier(malo_id) {
    if(validateVar(malo_id)) return malo_id;
    return '-/-';
}

export default getMarketIdentifier;